import actionTypes from '../actions/types';

export const INITIAL_STATE = {
  markets: [],
  topMovesArray: [],
};

export const reducer = (state, action) => {
  switch (action.type) {
    case actionTypes.SET_MARKETS_DATA:
      return { ...state, markets: [...action.data] };
    case actionTypes.SET_TOP_MOVERS:
      return { ...state, topMovesArray: [...action.data] };
    default:
      return state;
  }
};
